module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAxIiBoZWlnaHQ9IjI1OSIgdmlld0JveD0iMCAwIDMwMSAyNTkiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjMERCMDJCIiBkPSJNLjUuOTI4aDMwMHYyNTcuMTQzSC41eiIvPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0uNS45MjhoMzAwdjE3MS40MjlILjV6Ii8+PHBhdGggZmlsbD0iI0UwNTIwNiIgZD0iTS41LjkyOGgzMDB2ODUuNzE0SC41eiIvPjxjaXJjbGUgZmlsbD0iI0UwNTIwNiIgY3g9IjE1MC41IiBjeT0iMTI5LjUiIHI9IjM2LjQyOSIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-ne.svg
// module id = Emsf
// module chunks = 2